import { Flex } from "antd";
import styled from "styled-components";

import { FontItem } from "../types";
import { FontPreview } from "./FontPreview";

interface FontItemProps {
  variant: FontItem;
  showWeight?: boolean;
  isSelected: boolean;
  selectedBackgroundColor: string;
  onSelect: (fontItem: FontItem) => void;
  style?: React.CSSProperties;
}

export const FontItemComponent = ({
  variant,
  showWeight = false,
  isSelected,
  selectedBackgroundColor,
  onSelect,
  style,
}: FontItemProps) => {
  return (
    <StyledFontItem
      $isSelected={isSelected}
      $selectedBackgroundColor={selectedBackgroundColor}
      onClick={(e) => {
        e.stopPropagation();
        onSelect(variant);
      }}
      style={style}
    >
      <FontPreview fontItem={variant} showWeight={showWeight} />
    </StyledFontItem>
  );
};

const StyledFontItem = styled(Flex)<{
  $isSelected: boolean;
  $selectedBackgroundColor: string;
}>`
  padding: 4px 0;
  background-color: ${({ $isSelected, $selectedBackgroundColor }) =>
    $isSelected ? $selectedBackgroundColor : "transparent"};
  cursor: pointer;
  border-radius: 4px;
  border: none;
  margin: 0 -24px;
  padding-left: 24px;
  padding-right: 24px;
  &:hover {
    background-color: ${({ theme }) => theme.colorPrimaryBgHover};
  }
`;
